import React from 'react'

const Header = () => {
  return (
    <div className='w-full'>
      <header className='text-center'>
        <h1 className=' font-semibold text-3xl py-5 '>OTS Blogs</h1>
      </header>
    </div>
  )
}

export default Header
